// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-picks-nav-bar {
  width: 100%;
  background-color: #002129;
  padding: 0 16px;
  box-sizing: border-box;
  margin: 0 auto;
}
.my-picks-nav-bar-container {
  margin: 0 auto;
  width: 467px;
}
@media (max-width: 900px) {
  .my-picks-nav-bar-container {
    width: 310px;
  }
}
.my-picks-nav-bar-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.my-picks-nav-bar-select-container {
  flex: 1 1;
  display: flex;
  justify-content: center;
}
.my-picks-nav-bar-select {
  width: 300px;
}
@media (max-width: 900px) {
  .my-picks-nav-bar-select {
    width: 200px;
  }
}
.my-picks-nav-bar-select .MuiSelect-select {
  font-size: 24px !important;
  font-weight: 500 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 900px) {
  .my-picks-nav-bar-select .MuiSelect-select {
    font-size: 16px !important;
  }
}
.my-picks-nav-bar-select .MuiOutlinedInput-notchedOutline {
  border-color: transparent;
}
.my-picks-nav-bar-select:hover .MuiOutlinedInput-notchedOutline {
  border-color: transparent;
}
.my-picks-nav-bar-select.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: transparent;
}
.my-picks-nav-bar-select .MuiSvgIcon-root {
  font-size: 32px !important;
  margin-left: 8px;
  margin-right: -8px;
}
.my-picks-nav-bar-arrow-icon {
  font-size: 32px !important;
  color: inherit;
}
@media (max-width: 900px) {
  .my-picks-nav-bar-arrow-icon {
    font-size: 20px !important;
  }
}
.my-picks-nav-bar .MuiIconButton-root {
  padding: 8px;
  color: inherit;
}
.my-picks-nav-bar .MuiIconButton-root.Mui-disabled {
  opacity: 0.5;
}
.my-picks-nav-bar .MuiMenuItem-root {
  color: white;
}
.my-picks-nav-bar .MuiMenuItem-root.Mui-selected {
  color: white;
  background-color: rgba(255, 255, 255, 0.08);
}`, "",{"version":3,"sources":["webpack://./src/components/NavigationBars/MyPicksNavigation/MyPicksNavBar.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,yBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;AACJ;AACI;EACI,cAAA;EACA,YAAA;AACR;AACQ;EAJJ;IAKQ,YAAA;EAEV;AACF;AACI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AACR;AAEI;EACI,SAAA;EACA,aAAA;EACA,uBAAA;AAAR;AAGI;EACI,YAAA;AADR;AAGQ;EAHJ;IAIQ,YAAA;EAAV;AACF;AAEQ;EACI,0BAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAAZ;AAEY;EAVJ;IAWQ,0BAAA;EACd;AACF;AAEQ;EACI,yBAAA;AAAZ;AAGQ;EACI,yBAAA;AADZ;AAIQ;EACI,yBAAA;AAFZ;AAKQ;EACI,0BAAA;EACA,gBAAA;EACA,kBAAA;AAHZ;AAOI;EACI,0BAAA;EACA,cAAA;AALR;AAOQ;EAJJ;IAKQ,0BAAA;EAJV;AACF;AAOI;EACI,YAAA;EACA,cAAA;AALR;AAOQ;EACI,YAAA;AALZ;AASI;EACI,YAAA;AAPR;AASQ;EACI,YAAA;EACA,2CAAA;AAPZ","sourcesContent":[".my-picks-nav-bar {\n    width: 100%;\n    background-color: #002129;\n    padding: 0 16px;\n    box-sizing: border-box;\n    margin: 0 auto;\n\n    &-container {\n        margin: 0 auto;\n        width: 467px;\n\n        @media (max-width: 900px) {\n            width: 310px;\n        }\n    }\n\n    &-content {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    &-select-container {\n        flex: 1;\n        display: flex;\n        justify-content: center;\n    }\n\n    &-select {\n        width: 300px;\n    \n        @media (max-width: 900px) {\n            width: 200px;\n        }\n    \n        .MuiSelect-select {\n            font-size: 24px !important;\n            font-weight: 500 !important;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n    \n            @media (max-width: 900px) {\n                font-size: 16px !important;\n            }\n        }\n    \n        .MuiOutlinedInput-notchedOutline {\n            border-color: transparent;\n        }\n    \n        &:hover .MuiOutlinedInput-notchedOutline {\n            border-color: transparent;\n        }\n    \n        &.Mui-focused .MuiOutlinedInput-notchedOutline {\n            border-color: transparent;\n        }\n    \n        .MuiSvgIcon-root {\n            font-size: 32px !important;\n            margin-left: 8px;\n            margin-right: -8px;\n        }\n    }\n\n    &-arrow-icon {\n        font-size: 32px !important;\n        color: inherit;\n\n        @media (max-width: 900px) {\n            font-size: 20px !important;\n        }\n    }\n\n    .MuiIconButton-root {\n        padding: 8px;\n        color: inherit;\n\n        &.Mui-disabled {\n            opacity: 0.5;\n        }\n    }\n\n    .MuiMenuItem-root {\n        color: white;\n\n        &.Mui-selected {\n            color: white;\n            background-color: rgba(255, 255, 255, 0.08);\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
